import { React, Container } from "../../common";

const Component = () => {
    return (
        <>
            <Container footerType={"full"} showRates={true}>
                Reports
            </Container>

        </>
    );
};

export default Component;
